module.exports = __webpack_public_path__ + "img/season_allwetter.31d8cac1.svg";